// src/data/comedians/george-carlin.js

const base = {
  id: 'george-carlin',
  slug: 'george-carlin',
  name: 'George Carlin',
  birthYear: 1937,
  image: require('@/assets/images/img_George_Carlin.png'),
  famousWorks: [
    'Class Clown (1972)',
    'FM & AM (1972)',
    'Seven Words You Can Never Say on Television',
    "Jammin' in New York (1992)",
    'You Are All Diseased (1999)',
    "It's Bad for Ya (2008)",
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Counterculture icon and wordsmith',
    bio: `George Carlin was an American stand-up comedian, actor, author, and social critic known for his dark comedy and sharp reflections on politics, language, religion, and taboo subjects. Over five decades, he became one of the most important and influential stand-up comedians in American history.\n\nBorn in New York City, Carlin began in radio before transitioning to stand-up. In the 1970s he transformed into a counterculture figure, focusing on social commentary and challenging societal norms. His "Seven Words" routine led to a landmark Supreme Court case on censorship.\n\nWith 14 HBO specials and numerous bestselling books, Carlin's legacy as a fearless social commentator and master of language continues to influence comedians and free speech advocates worldwide.`,
    style: 'Observational, social criticism, wordplay, dark humor, philosophical',
    achievements: [
      'Five Grammy Awards',
      'Mark Twain Prize for American Humor (2008)',
      '14 HBO comedy specials',
      'Four bestselling books',
      "Ranked #2 on Comedy Central's list of all-time greatest stand-ups",
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Icône de la contre-culture et virtuose des mots',
    bio: `George Carlin était un comédien de stand-up, acteur, auteur et critique social américain connu pour son humour noir et ses réflexions acérées sur la politique, le langage, la religion et les sujets tabous. Sur cinq décennies, il est devenu l'un des humoristes les plus importants et influents de l'histoire américaine.\n\nNé à New York, Carlin débuta à la radio avant de se tourner vers le stand-up. Dans les années 1970, il se transforma en figure de la contre-culture, axant son travail sur le commentaire social. Son sketch des "Sept mots" donna lieu à un arrêt historique de la Cour suprême sur la censure.\n\nAvec 14 specials HBO et plusieurs livres best-sellers, son héritage continue d'influencer les comédiens et les défenseurs de la liberté d'expression.`,
    style: 'Observationnel, critique sociale, jeux de mots, humour noir, philosophique',
    achievements: [
      'Cinq Grammy Awards',
      'Mark Twain Prize for American Humor (2008)',
      '14 specials comiques sur HBO',
      'Quatre livres best-sellers',
      "Classé n°2 par Comedy Central parmi les plus grands humoristes de tous les temps",
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Icono de la contracultura y maestro de las palabras',
    bio: `George Carlin fue un comediante de stand-up, actor, autor y crítico social estadounidense conocido por su humor negro y sus agudas reflexiones sobre política, lenguaje, religión y temas tabú. A lo largo de cinco décadas se convirtió en uno de los comediantes más importantes e influyentes de la historia americana.\n\nNacido en Nueva York, Carlin comenzó en la radio antes de pasarse al stand-up. En los años 70 se transformó en figura de la contracultura. Su rutina de las "Siete palabras" dio lugar a un histórico caso en la Corte Suprema sobre la censura.\n\nCon 14 especiales en HBO y varios libros bestsellers, su legado sigue influyendo en comediantes y defensores de la libertad de expresión de todo el mundo.`,
    style: 'Observacional, crítica social, juegos de palabras, humor negro, filosófico',
    achievements: [
      'Cinco Grammy Awards',
      'Mark Twain Prize for American Humor (2008)',
      '14 especiales de comedia en HBO',
      'Cuatro libros bestsellers',
      "Clasificado n.º 2 por Comedy Central entre los mejores stand-ups de todos los tiempos",
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'أيقونة الثقافة المضادة وسيّد الكلمة',
    bio: `جورج كارلين كوميدي ستاند أب وممثل وكاتب وناقد اجتماعي أمريكي اشتُهر بكوميديا داكنة وتأملاته الحادة في السياسة واللغة والدين والموضوعات المحظورة. على مدى خمسة عقود، أصبح أحد أهم الكوميديين الأمريكيين وأكثرهم تأثيرًا.\n\nوُلد في نيويورك وبدأ في الراديو قبل أن يتحوّل إلى الستاند أب. في السبعينيات تحوّل إلى رمز للثقافة المضادة، مركّزًا على التعليق الاجتماعي. أفضت فقرته عن "الكلمات السبع" إلى قضية تاريخية أمام المحكمة العليا بشأن الرقابة.\n\nمع 14 عرضًا خاصًا على HBO وعدة كتب من أكثر المبيعات، يواصل إرثه التأثير في الكوميديين والمدافعين عن حرية التعبير.`,
    style: 'ملاحظاتي، نقد اجتماعي، لعب بالألفاظ، فكاهة داكنة، فلسفي',
    achievements: [
      'خمس جوائز Grammy',
      'جائزة مارك توين للفكاهة الأمريكية (2008)',
      '14 عرضًا كوميديًا خاصًا على HBO',
      'أربعة كتب من أكثر المبيعات',
      'صنّفته Comedy Central الثاني في قائمة أعظم كوميديي الستاند أب على الإطلاق',
    ],
  },
];
